import {connect} from "react-redux";
import LoginSso from "./LoginSso";
import {bindActionCreators} from "redux";
import {ssoGoogleLogin} from "../../../service/Login/action";
const mapStateToProps = (state) => ({
    ssoLoginDetail:state.LoginReducerSSO.ssoLoginDetail,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ssoGoogleLogin
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LoginSso);
